import { defineAsyncComponent } from 'vue';
import http from "@/api.js";
import resolution from '@/libraries/votesystem/mixins/resolution.js';
import participant from '@/libraries/votesystem/mixins/participant.js';
import vote from '@/libraries/votesystem/mixins/vote.js';

export default {
    mixins: [resolution, participant,  vote,],
    emits: ["vote-init", "vote-change", "vote-modal-close",],
    data: () => ({
        vote_modal_open_force: false,
        active_menu: "vote",
        meetingapi: "/meetings/",
        meetingdata: {},
        vote_icons: {
            FOR: "check",
            AGAINST: "block",
            ABSTAINS: "radio_button_checked"
        }
    }),
    components: {
        VoteModal: defineAsyncComponent(() => import('@/libraries/votesystem/Modal.vue')),
        VoteParticipants: defineAsyncComponent(() => import('@/libraries/votesystem/Participants.vue')),
        VoteSystemCaleol: defineAsyncComponent(() => import('@/libraries/votesystem/systems/Caleol.vue')),
        VoteSystemClassic: defineAsyncComponent(() => import('@/libraries/votesystem/systems/Classic.vue')),
        VoteSystemCustom: defineAsyncComponent(() => import('@/libraries/votesystem/systems/Custom.vue')),
        VoteSystemMultiple: defineAsyncComponent(() => import('@/libraries/votesystem/systems/Multiple.vue')),
        VoteTickets: defineAsyncComponent(() => import('@/libraries/votesystem/systems/Tickets.vue')),
    },
    props: {
        graphic: { type: Boolean, default: false, },
        button_start: { type: [Boolean, Number], default: false, },
        button_text: { type: String, default: "Voter / Signer", },
        vote_busy: { type: Boolean, default: false, },
        readonly: { type: Boolean, default: false, },
        vote_modal_open: { type: [Boolean, Number], default: false, },
        mode_modal: { type: Boolean },
        meeting: { type: String, },
        group: { type: String, },
        only_sign: { type: Boolean, default: false, },
        manage: { type: Boolean, default: false, },
    },
    computed: {
        data_ready(){ return this.resolution_ready == 2 && this.participant_ready == 2 && this.vote_ready ==2; },
        content_nb(){
            if(this.isStepSignature) return 2
            else if(this.data_ready) return 3;
            return 1;
         },
    },
    methods: {
        VoteSystemToUse(resolution){ return "VoteSystem"+resolution.vote_system },
        meetingUrl(group, uid, suffix){
            suffix = suffix || "";
            const url = "/api/"+group+this.meetingapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        loadMeeting(){
            return http.get(this.meetingUrl(this.group, this.meeting)).then(response => {
                this.meetingdata = response.data;
            });
        },
    }
}
